





















import { Vue, Component } from 'vue-property-decorator'
import { Route } from 'vue-router'
import * as drills from '@/drills'

import { DrillField, DrillParam } from '@/types'
import OptionGroup from './OptionGroup.vue'

@Component({ components: { OptionGroup } })
export default class Drill extends Vue {

	generator: ((params: any) => DrillField[]) | undefined
	drillName: string = ''
	fields: DrillField[] = []
	params: any = {}
	paramFields: DrillParam[] = []

	generate() {
		if(!this.generator) {
			return
		}
		this.fields = this.generator(this.params)
	}

	hotkeys(e: KeyboardEvent) {
		if(e.key === ' ') {
			this.generate()
		}
	}

	created() {
		document.addEventListener('keyup', this.hotkeys)
		this.drillName = this.$route.params.drill
		this.generator = (drills as any)[this.drillName]
		this.paramFields = (this.generator as any).params
		this.params = this.paramFields.reduce((params: any, p) => {
			params[p.title] = p.options
			return params
		}, {})
	}

	destroyed() {
		document.removeEventListener('keyup', this.hotkeys)
	}

}
